import useReveal from "@/hooks/useReveal";
import { ideas } from "@/lib/offers";

export default function IdeaBlocks() {
    const { ref, visible } = useReveal();
    return (
        <section id="ideas" data-testid="ideas-section" className="bg-[#f6f7fb] px-5 py-14 sm:py-20">
            <div className="mx-auto max-w-5xl">
                <div ref={ref} className={`reveal mb-9 max-w-2xl ${visible ? "is-visible" : ""}`}>
                    <span className="rounded-full bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[var(--brand)] ring-1 ring-black/5">
                        How we work
                    </span>
                    <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-[#0a0a0b] sm:text-4xl">
                        Five things that stay true.
                    </h2>
                </div>
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
                    {ideas.map((idea, i) => (
                        <Idea key={idea.title} idea={idea} i={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}

function Idea({ idea, i }) {
    const { ref, visible } = useReveal({ threshold: 0.15 });
    return (
        <article
            ref={ref}
            style={{ transitionDelay: `${i * 60}ms` }}
            className={`reveal rounded-3xl bg-white p-5 ring-1 ring-black/5 ${visible ? "is-visible" : ""}`}
        >
            <div className="font-mono-tech text-[11px] uppercase tracking-[0.18em] text-[var(--brand)]">
                {String(i + 1).padStart(2, "0")}
            </div>
            <h3 className="mt-3 font-display text-lg font-bold text-[#0a0a0b]">{idea.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#5b5b66]">{idea.body}</p>
        </article>
    );
}
